import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";

export default function ArcDesign({valueFromParent,colorFromParent}) {
  const settings = {
    width: 200,
    height: 200,
    value: valueFromParent,
  };
  return (
    <div className="w-full h-[300px] bg-white rounded-3xl flex items-center justify-center p-4">
      <Gauge
        {...settings}
        cornerRadius="50%"
        sx={(theme) => ({
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: 40,
          },
          [`& .${gaugeClasses.valueArc}`]: {
            fill: colorFromParent,
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: theme.palette.text.disabled,
          },
        })}
      />
    </div>
  );
}
